import styles from "./content.module.css";

const ContentBody = (props) => {
  return (
    <div className={styles.content_body_container} style={props?.style}>
      {props.children}
    </div>
  );
};

export default ContentBody;
